module.exports = __webpack_public_path__ + "td/img/401.c3f1f58f.gif";